import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";
import SlidersArray2 from "./SliderArray2";
import ImageUpdateValue from "../../components/shared/ImageUpdateValue";
import SlidersArrayTeam from "./SlidersArrayTeam";
import SlidersArrayFaqs from "./SlidersArrayFaqs";
import { Editor } from "components/shared/Editor";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [sliders, setSliders] = useState([]);
  const [sliders2, setSliders2] = useState([]);
  const [slidersTeam, setSlidersTeam] = useState([]);
  const [slidersFaqs, setSlidersFaqs] = useState([]);
  // const [selectedImage, setSelectedImage] = useState({
  //   preview: null,
  //   path: "",
  // });
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "faqs",
  });

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "about",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);

    setSliders(section?.sliders);
    setSliders2(section?.specialists);
    setSlidersTeam(section?.team);
    // setSlidersFaqs(section?.faqs);

    // setSelectedImage({
    //   preview: null,
    //   path: section?.image,
    // });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // if (!selectedImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }

    // data.image = `/uploads/${selectedImage?.path?.split("/").pop()}`;

    data.sliders = sliders;
    data.specialists = sliders2;
    data.team = slidersTeam;
    // data.faqs = slidersFaqs;
    dispatch(
      editSection({ slug: "about", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"about"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col md={12}>
                {/* image  */}
                <Col xs={12}>
                  <div className="form-group">
                    <h5>
                      <FormattedMessage id="firstSectionImages" />
                    </h5>
                    <Row>
                      <Col xs="12" md="6">
                        <Controller
                          name="firstSectionImage1"
                          control={control}
                          rules={{ required: true }}
                          render={({ field: { value, onChange } }) => (
                            <ImageUpdateValue
                              title=""
                              value={value}
                              setValue={(value) => onChange(value)}
                            />
                          )}
                        />
                      </Col>
                      <Col xs="12" md="6">
                        <Controller
                          name="firstSectionImage2"
                          control={control}
                          rules={{ required: true }}
                          render={({ field: { value, onChange } }) => (
                            <ImageUpdateValue
                              title=""
                              value={value}
                              setValue={(value) => onChange(value)}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>

                {/* description */}
                <Row>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name="description.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name="description.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <SlidersArray sliders={sliders} setSliders={setSliders} />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="secondSectionImages" />
                      </h5>
                      <Row>
                        <Col xs="12" md="6">
                          <Controller
                            name="secondSectionImage1"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                              <ImageUpdateValue
                                title=""
                                value={value}
                                setValue={(value) => onChange(value)}
                              />
                            )}
                          />
                        </Col>
                        <Col xs="12" md="6">
                          <Controller
                            name="secondSectionImage2"
                            control={control}
                            rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                              <ImageUpdateValue
                                title=""
                                value={value}
                                setValue={(value) => onChange(value)}
                              />
                            )}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="secondHeading"
                      name="secondHeading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="secondHeading"
                      name="secondHeading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="secondDescription"
                      name="secondDescription.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="secondDescription"
                      name="secondDescription.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="specialistsTitle"
                      name="specialistsTitle.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="specialistsTitle"
                      name="specialistsTitle.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="specialistsDescription"
                      name="specialistsDescription.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="specialistsDescription"
                      name="specialistsDescription.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <SlidersArray2
                      sliders={sliders2}
                      setSliders={setSliders2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="teamTitle"
                      name="teamTitle.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="teamTitle"
                      name="teamTitle.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <SlidersArrayTeam
                      sliders={slidersTeam}
                      setSliders={setSlidersTeam}
                    />
                  </Col>
                </Row>
                {/* <Row>
                  <Col lg={12}>
                    <SlidersArrayFaqs
                      sliders={slidersFaqs}
                      setSliders={setSlidersFaqs}
                    />
                  </Col>
                </Row> */}
                <hr />
                <div className="form-group">
                  <h5 className="fs-5">
                    <FormattedMessage id={"faqs"} />
                  </h5>
                </div>
                <Col xs="12" md="6">
                  <Controller
                    name="faqImage"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <ImageUpdateValue
                        value={value}
                        setValue={(value) => onChange(value)}
                      />
                    )}
                  />
                </Col>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="faqsTitle"
                      name="faqsTitle.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="faqsTitle"
                      name="faqsTitle.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <div className="branches form-group">
                  {fields.map((item, index) => (
                    <Row key={index} className="add-multi-component">
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register(`faqs.${index}.label.ar`)}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"title"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register(`faqs.${index}.label.en`)}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} /> ({" "}
                            <FormattedMessage id={"arabic-language"} /> )
                          </h5>
                          <Controller
                            name={`faqs.${index}.description.ar`}
                            control={control}
                            render={({ field: { value, onChange } }) => (
                              <Editor
                                initialValue={value}
                                onChange={(e, editor) => {
                                  const data = editor.getContent();
                                  onChange(data);
                                }}
                              />
                            )}
                          />
                        </div>
                      </Col>
                      <Col lg={6} xs={12}>
                        <div className="form-group">
                          <h5>
                            <FormattedMessage id={"description"} /> ({" "}
                            <FormattedMessage id={"english-language"} /> )
                          </h5>
                          <Controller
                            name={`faqs.${index}.description.en`}
                            control={control}
                            render={({ field: { value, onChange } }) => (
                              <Editor
                                initialValue={value}
                                onChange={(e, editor) => {
                                  const data = editor.getContent();
                                  onChange(data);
                                }}
                              />
                            )}
                          />
                        </div>
                      </Col>
                    </Row>
                  ))}
                </div>
                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
